export default __webpack_public_path__ + "static/media/md-logo-vr.45604304.png";